import { cloneDeep } from 'lodash';
import { isEmpty } from '@/common/utils/Util';

export default {
  setLawList: (state, list) => {
    if (isEmpty(state.lawList)) {
      state.lawList = list;
    } else {
      state.lawList = [...state.lawList, ...list];
    }
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.lawList = [];
  }
};
